<p>ici se trouve la liste des commercants qui souhaite s'inscrire. le designe sera sous forme de liste avec un bouton "accepter" et un bouton "décliner"</p>
cela sera fait dès la connection avec le backend.


